export let goToCopilot = "tXs64d";
export default {goToCopilot};